<template>
  <div class="app-lightbox">
    <div class="lightbox__control">
      <picture @click="handleLightboxOpen">
        <slot name="lightboxImage" />
      </picture>
      <div class="lightbox__title">
        <p class="title" @click="handleLightboxOpen">
          <slot name="lightboxTitle" />
        </p>
        <p class="subtitle" @click="handleLightboxOpen">
          看<slot name="lightboxSubtitle" />的故事
        </p>
      </div>
    </div>
    <div
      v-show="openLightbox"
      :class="{ active: openLightbox }"
      class="lightbox__content"
      body-scroll-lock-ignore
    >
      <div class="content-container">
        <ButtonClose
          class="btn--close"
          @click="handleLightboxClose"
        />
        <div class="content">
          <slot name="lightboxContent" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import ButtonClose from './ButtonClose.vue'

export default {
  name: 'AppLightbox',
  props: {
    gaIndex: {
      type: Number,
      required: true
    }
  },
  components: {
    ButtonClose
  },
  data () {
    return {
      openLightbox: false
    }
  },
  watch: {
    openLightbox  (value) {
      this.$nextTick(() => {
        const content = document.querySelector('.lightbox__content.active .content')
        value ? disableBodyScroll(content) : clearAllBodyScrollLocks()
      })
    }
  },
  methods: {
    handleLightboxClose () {
      this.openLightbox = false
    },
    handleLightboxOpen () {
      window.gtag && window.gtag('event', 'click', { 'event_category': 'projects', 'event_label': `點人物故事 ${this.gaIndex}` })
      this.openLightbox = true
    }
  }
}
</script>
<style lang="scss" scoped>
.app-lightbox {
  padding: 31px 0;
  border-top: 1px solid #979797;
  border-bottom: 1px solid #979797;
  @media (min-width: 1200px) {
    position: relative;
    padding: 0;
    border: none;
  }
}

.lightbox {
  &__control {
    display: flex;
    justify-content: center;
    @media (min-width: 1200px) {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(calc(100% + 43px));
    }
    picture {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
      opacity: 0.6;
      transition: 0.5s opacity ease-in;
      &:hover {
        opacity: 1;
      }
      img {
        width: 100%;
        height: 100%;
        min-height: 0;
        object-fit: cover;
        object-position: center center;
      }
    }
  }
  &__title {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 16px;
    @media (min-width: 768px) {
      flex: none;
    }
    p {
      cursor: pointer;
      &.title {
        font-size: 18px;
        font-weight: 900;
        font-family: source-han-serif-tc,serif;
        line-height: normal;
      }
      &.subtitle {
        margin-top: 7px;
        color: rgba(0, 0, 0, 0.66);
        font-size: 13px;
        line-height: 1.5;
        &::after {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          margin-left: 5px;
          vertical-align: baseline;
          border-style: solid;
          border-width: 5px 0 5px 5px;
          border-color: transparent transparent transparent rgba(0, 0, 0, 0.66);
        }
      }
    }
  }
  &__content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 910;
    width: 100%;
    height: 100%;
    padding: 8px 10px;
    background-color: rgba(0, 0, 0, 0.1);
    @media (min-width: 768px) {
      padding: 8px calc((100% - 634px) / 2);
    }
    @media (min-width: 1024px) {
      padding: 50px 80px;
    }
    @media (min-width: 1200px) {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
    .content-container {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 46px 5px 40px 17px;
      background-color: #ffffff;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
      overflow: auto;
      @media (min-width: 1024px) {
        padding: 126px 46px 50px;
        overflow: hidden;
      }
      @media (min-width: 1200px) {
        width: auto;
        max-width: 90%;
        height: calc(100% - 100px);
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 39px;
        width: 100%;
        height: 71px;
        background: linear-gradient(to top, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        @media (min-width: 1024px) {
          width: calc(50% + 46px);
        }
      }
      .content {
        width: 100%;
        height: 100%;
        padding-right: 12px;
        overflow-y: auto;
        @media (min-width: 1024px) {
          width: calc(50% + 46px);
          max-width: 594px;
          padding-right: 46px;
        }
        @media (min-width: 1200px) {
          min-width: 594px;
          margin-right: 594px;
        }
        > *:last-child {
          padding-bottom: 70px;
        }
        h2 {
          width: calc(100% - 54px);
          & + * {
            margin-top: 40px;
          }
          @media (min-width: 1024px) {
            position: absolute;
            top: 50px;
            left: 46px;
            width: 50%;
          }
        }
        h3 + p {
          margin-top: 40px;
        }
        p + p {
          margin-top: 2em;
        }
        p + h3 {
          margin-top: 50px;
        }
      }
    }
    .btn--close {
      position: absolute;
      top: 10px;
      right: 10px;
      @media (min-width: 768px) {
        top: 10px;
        right: 10px;
      }
      @media (min-width: 1024px) {
        top: 12px;
        right: 12px;
      }
    }
  }
  &__image {
    @media (min-width: 1024px) {
      position: absolute;
      top: 126px;
      right: 46px;
      width: calc(50% - 92px);
      margin: 0 !important;
    }
    @media (min-width: 1200px) {
      width: calc(100% - 594px - 92px - 46px);
    }
  }
}

</style>
